import { createRouter, createWebHistory } from "vue-router"
import { useAuthenticationStore } from "@/stores/useAuthStore"
import Login from "@/views/Login.vue"
import Homepage from "@/views/Homepage.vue"
import Betreuer from "@/views/Betreuer.vue"
import Archiv from "@/views/Archiv.vue"
import Fortschritt from "@/views/Fortschritt.vue"
import Projekte from "@/views/Projekte.vue"


const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/homepage",
    name: "Homepage",
    component: Homepage,
    meta: { requiresAuth: true },
  },
  {
    path: "/betreuer",
    name: "Betreuer",
    component: Betreuer,
    meta: { requiresAuth: true },
  },
  {
    path: "/archiv",
    name: "Archiv",
    component: Archiv,
    meta: { requiresAuth: true },
  },
  {
    path: "/fortschritt",
    name: "Fortschritt",
    component: Fortschritt,
    meta: { requiresAuth: true },
  },
  {
    path: "/projekte",
    name: "Projekte",
    component: Projekte,
    meta: { requiresAuth: true },
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthenticationStore()
  if (!authStore.loaded) {
    await authStore.checkAuth()
  }
  if (to.meta.requiresAuth && !authStore.loggedIn) {
    return next({ path: "/" })
  }
  if (to.path === "/" && authStore.loggedIn) {
    return next({ path: "/homepage" })
  }
  next()
})

export default router
